module.exports = __webpack_public_path__ + "static/media/icmui_1201.9e2781da.ico";